import { NgClass } from '@angular/common';
import { ChangeDetectionStrategy, Component, computed, contentChildren, effect, input } from '@angular/core';
import { ButtonComponent } from '../button.component';
import { ButtonSize, ButtonType } from '../button.types';

@Component({
  imports: [NgClass],
  selector: 'mbs-group-button',
  templateUrl: './group-button.component.html',
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class GroupButtonComponent {
  #lastItemsCounter: number[] = [];

  public readonly customClasses = input<string>('');
  public readonly multiple = input<boolean>(false);
  public readonly toggle = input<boolean>(false);
  public readonly size = input<ButtonSize>(null);
  public readonly vertical = input<boolean>(false);
  public readonly type = input<ButtonType>(null);
  public readonly disabled = input<boolean>(null);

  protected buttonsItems = contentChildren(ButtonComponent, { descendants: true });

  protected buttonGroupClasses = computed(() => {
    const size = this.size();
    const type = this.type();

    return [
      size && `mbs-btn-group_${size}`,
      type && `mbs-btn-group_${type}`,
      this.vertical() && 'btn-group-vertical mbs-btn-group_vertical',
      this.customClasses()
    ].filter(Boolean);
  });

  protected readonly activeEffect = effect(() => {
    if (!this.toggle()) return;

    const buttons = this.buttonsItems();
    const newCounters = buttons.map((item) => item.clickCounter());
    const changedIdx = newCounters.findIndex((val, i) => val !== (this.#lastItemsCounter[i] ?? 0));

    this.#lastItemsCounter = newCounters;

    if (changedIdx === -1) return;

    if (this.multiple()) {
      buttons[changedIdx].active.update((active) => !active);
    } else {
      buttons.forEach((b, idx) => b.active.update((active) => (idx === changedIdx ? !active : false)));
    }
  });
  protected readonly disabledEffect = effect(
    () => this.disabled() != null && this.buttonsItems().forEach((b) => b.disabled.set(this.disabled()))
  );
  protected readonly typeEffect = effect(() => this.buttonsItems().forEach((b) => b.type.set(b.type() || this.type())));
}
